<script>
    import {durationUnitRegex, range} from '../utils';
    import {getCurrentTheme} from '../themeLoader.js';

    const currentTheme = getCurrentTheme();
    const defaultColor = currentTheme === 'winter_theme' ? '#96e3ff' : '#ff958a';

    let { color = defaultColor, unit = 'px', duration = '1s', size = '100' } = $props();

    let durationUnit = $derived(duration.match(durationUnitRegex)[0]);
    let durationNum = $derived(duration.replace(durationUnitRegex, ''));
</script>

<div
        class="loader"
        style="--size: {size}{unit}; --color: {color}; --duration: {duration};"
>
    {#each range(3, 1) as version}
        <div
                class="circle"
                style="animation-delay: {(durationNum / 3) * (version - 1) +
        durationUnit};"
        ></div>
    {/each}
</div>

<style>
    .loader {
        width: var(--size);
        height: var(--size);
        position: relative;
        margin: 40px auto;
    }

    .circle {
        border-radius: 100%;
        animation-fill-mode: both;
        position: absolute;
        opacity: 0;
        width: var(--size);
        height: var(--size);
        background-color: var(--color);
        animation: bounce var(--duration) linear infinite;
    }

    @keyframes bounce {
        0% {
            opacity: 0;
            transform: scale(0);
        }
        5% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    }
</style>
